import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ProductBundles/productBundles.container"
    ).then((module) => ({
        default: module.ProductBundles
    }))
);
